export default __webpack_public_path__ + "static/media/long-arrow-left-azure.37953cec.svg";